/**
 * TKP-64 / tasarım s.4 md.1 — "baz seviyesinde düzenlemeyi kaldırıp tüm envanter özelliklerini her seviyeden yapabilmek".
 * Envanter tablosunda birim, süreç, veri ve ilgili kişi hücresinden toplu güncelleme paneli o satırın kapsamıyla açılır:
 * kaynak, veri ve ilgili kişi özelliklerinin hepsi kapsamın altındaki kayıtlara uygulanır. Bu yardımcı kapsamı envanter
 * filtresinin kriter mutasyonlarına çevirir (Varlıklar kartlarıyla aynı kriterler). Saf.
 */
const ref = (x) => (x && x._id ? { _id: x._id, name: x.name } : null);

export const LEVELS = ["department", "process", "data", "datasubject"];

export const rowBulkCommits = (level, { department, process, node, datasubject } = {}) => {
  const depth = LEVELS.indexOf(level);
  if (depth < 0) throw new Error(`unknown level: ${level}`);
  const commits = [["department", ref(department)]];
  if (depth >= 1) commits.push(["process", ref(process)]);
  if (depth >= 2) commits.push(["data", ref(node && node.data)]);
  if (depth >= 3) commits.push(["datasubject", ref(datasubject && datasubject.datasubject)]);
  if (commits.some(([, v]) => !v)) throw new Error(`incomplete scope for ${level}`);
  return commits;
};
